module.exports = __webpack_public_path__ + "static/WSC_Group_2015_Individual_Income_Tax_Return_Checklist-f94b42c1a9bc5086cd2573bc4b8c46ac.pdf";